import {connectWrap as connect} from '@viskan/deku-redux';
import Component from '@viskan/deku-link';

export default connect(
	({router, site}, props) => ({
		localeMode: site.localeMode,
		prefix: props.prefix || router.pathPrefix
	})
)(Component);
